export enum TabType {
  Purchases = 'purchases',
  Settings = 'settings',
  Support = 'support',
}
